import { Chip, styled } from '@mui/material';

export const StyledRemixerTag = styled(Chip)(() => ({}));
StyledRemixerTag.defaultProps = {
  variant: 'outlined',
};

export const StyledSecondaryTag = styled(StyledRemixerTag)(({ theme }) => ({
  color: theme.palette.warning.main,
  borderColor: theme.palette.warning.main,
}));
